// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMessageOutlinedSvg from "@fishx/icons-svg/es/asn/PMessageOutlined";
import FishxIcon from '../components/FishxIcon';

var PMessageOutlined = function PMessageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMessageOutlinedSvg
  }));
};

PMessageOutlined.displayName = 'PMessageOutlined';
export default React.forwardRef(PMessageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMessageOutlined.js
// module id = 3510
// module chunks = 0